import { ChevronRight, UserRound, X } from 'lucide-react'

import { Kbd } from '@/components/ui'
import { PosModel } from '@/types'
import { initials } from '@/utils'

interface CustomerChipProps {
  customer?: PosModel.Customer
  onPick: () => void
  onClear: () => void
}

export const CustomerChip = ({ customer, onPick, onClear }: CustomerChipProps) => (
  <div className="flex items-center gap-2 rounded-md border border-border bg-card p-1.5 pr-2 shadow-z1">
    <button type="button" onClick={onPick} className="flex min-w-0 flex-1 items-center gap-3 rounded-md p-1 text-left hover:bg-subdued">
      <span className="grid size-9 shrink-0 place-items-center rounded-full bg-fill text-xs font-semibold text-ink">
        {customer ? initials(customer.name) : <UserRound className="size-4" />}
      </span>
      <span className="min-w-0 flex-1">
        <span className="block truncate text-sm font-medium text-ink">{customer?.name ?? 'Walk-in customer'}</span>
        <span className={customer ? 'block truncate text-xs text-muted-foreground' : 'block text-xs text-muted-foreground'}>
          {customer ? `${customer.phone} · ${customer.loyalty_points} pts` : 'No price book, no credit. Pick a customer to apply theirs.'}
        </span>
      </span>
      {!customer && <Kbd>F3</Kbd>}
      {!customer && <ChevronRight className="size-4 text-muted-foreground" />}
    </button>
    {customer && (
      <button type="button" onClick={onClear} aria-label="Remove customer" className="grid size-8 place-items-center rounded-full text-muted-foreground hover:bg-fill">
        <X className="size-4" />
      </button>
    )}
  </div>
)
